var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSazoneColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244.245,
    height: 112.742,
    viewBox: "0 0 244.245 112.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_362",
    "data-name": "Rect\\xE1ngulo 362",
    width: 244.245,
    height: 112.742,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sazone-color",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27157",
    "data-name": "Trazado 27157",
    d: "M343.659,271.285c-.007,1.728-1.264,2.766-3.329,2.758l-2.18-.009-.011,2.562-.858,0,.033-8.116,3.038.013c2.065.008,3.312,1.057,3.3,2.8m-.858,0c.005-1.3-.85-2.044-2.473-2.051l-2.157-.008-.016,4.058,2.157.009c1.623.007,2.486-.732,2.49-2.008",
    transform: "translate(-206.428 -164.317)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27158",
    "data-name": "Trazado 27158",
    d: "M360.455,274.545l-4.522-.019-.982,2.165-.893,0,3.743-8.1.846,0,3.677,8.132-.9,0Zm-.31-.7-1.93-4.368-1.966,4.352Z",
    transform: "translate(-216.696 -164.384)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27159",
    "data-name": "Trazado 27159",
    d: "M376.846,275.681l.337-.66a3.986,3.986,0,0,0,2.677,1c1.517.006,2.182-.629,2.186-1.429.009-2.226-4.994-.878-4.981-3.881.005-1.194.937-2.223,3-2.214a4.582,4.582,0,0,1,2.513.729l-.295.683a4.181,4.181,0,0,0-2.224-.682c-1.484-.006-2.149.653-2.149,1.464-.009,2.226,4.994.9,4.981,3.858,0,1.195-.96,2.211-3.034,2.2a4.4,4.4,0,0,1-3.011-1.067",
    transform: "translate(-230.643 -164.328)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_359",
    "data-name": "Rect\\xE1ngulo 359",
    width: 8.116,
    height: 0.858,
    transform: "translate(154.109 112.372) rotate(-89.767)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27160",
    "data-name": "Trazado 27160",
    d: "M404.44,269.535a4.263,4.263,0,1,1,4.25,4.145,4.085,4.085,0,0,1-4.25-4.145m7.664.032a3.409,3.409,0,1,0-3.413,3.349,3.287,3.287,0,0,0,3.413-3.349m-2.537-6.167,1.1,0-1.884,1.428-.812,0Z",
    transform: "translate(-247.531 -161.21)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27161",
    "data-name": "Trazado 27161",
    d: "M438.147,268.89l-.033,8.116-.707,0-5.191-6.609-.027,6.586-.858,0,.033-8.116.707,0,5.2,6.607.027-6.586Z",
    transform: "translate(-263.989 -164.552)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27162",
    "data-name": "Trazado 27162",
    d: "M461.656,272.961a4.075,4.075,0,0,1,4.272-4.11,3.928,3.928,0,0,1,2.963,1.194l-.548.543a3.218,3.218,0,0,0-2.4-.972,3.363,3.363,0,1,0-.027,6.726,3.182,3.182,0,0,0,2.4-.965l.543.548a3.947,3.947,0,0,1-2.985,1.182,4.073,4.073,0,0,1-4.227-4.145",
    transform: "translate(-282.55 -164.545)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27163",
    "data-name": "Trazado 27163",
    d: "M484.759,273.731l.019-4.649.859,0-.019,4.614c-.008,1.925.893,2.81,2.47,2.816s2.5-.871,2.5-2.8l.019-4.615.835,0-.019,4.649c-.009,2.331-1.267,3.531-3.342,3.523s-3.335-1.22-3.325-3.55",
    transform: "translate(-296.689 -164.688)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27164",
    "data-name": "Trazado 27164",
    d: "M508.612,269.181l.858,0-.03,7.374,4.546.019,0,.742-5.4-.022Z",
    transform: "translate(-311.268 -164.748)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_360",
    "data-name": "Rect\\xE1ngulo 360",
    width: 8.116,
    height: 0.858,
    transform: "translate(204.142 112.577) rotate(-89.767)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27165",
    "data-name": "Trazado 27165",
    d: "M542.029,269.319,542,277.436l-.707,0-5.191-6.607-.027,6.586-.858,0,.033-8.116.708,0,5.2,6.607.027-6.586Z",
    transform: "translate(-327.569 -164.816)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27166",
    "data-name": "Trazado 27166",
    d: "M562.566,275.375l-4.522-.019-.982,2.165-.893,0,3.743-8.1.847,0,3.677,8.132-.9,0Zm-.31-.7-1.93-4.368-1.966,4.352Z",
    transform: "translate(-340.395 -164.892)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27167",
    "data-name": "Trazado 27167",
    d: "M585.46,274.83a2.516,2.516,0,0,0,1.865-2.543c.008-1.739-1.24-2.788-3.3-2.8l-3.037-.013-.033,8.116.858,0,.011-2.574,2.18.009a5.924,5.924,0,0,0,.65-.032l1.844,2.617.939,0Zm-1.482-.528-2.157-.009.017-4.069,2.157.009c1.623.006,2.478.752,2.473,2.05-.005,1.275-.867,2.026-2.489,2.019",
    transform: "translate(-355.561 -164.93)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_361",
    "data-name": "Rect\\xE1ngulo 361",
    width: 8.116,
    height: 0.858,
    transform: "translate(233.774 112.699) rotate(-89.767)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27168",
    "data-name": "Trazado 27168",
    d: "M612.833,269.633l-.846,0-3.744,8.1.893,0,.983-2.164,4.522.019.966,2.173.9,0Zm-2.4,5.243,1.965-4.352,1.931,4.368Z",
    transform: "translate(-372.266 -165.023)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27169",
    "data-name": "Trazado 27169",
    d: "M40.539,151.024a28.98,28.98,0,1,1,29.28-28.678,28.98,28.98,0,0,1-29.28,28.678m.572-55.114a26.137,26.137,0,1,0,25.865,26.407A26.137,26.137,0,0,0,41.111,95.91",
    transform: "translate(-7.259 -56.959)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27170",
    "data-name": "Trazado 27170",
    d: "M63.242,11.409A16.355,16.355,0,0,0,56.589,5c-3.781-1.821-8.545-2.293-12.328-.361A14.476,14.476,0,0,0,39,9.408c-2.81,3.979-2.236,9.222.027,13.342,2.277,4.4,6.178,7.437,10.008,10.513a66.828,66.828,0,0,1,7.967,7.061,55.07,55.07,0,0,1,7.407,10.243A34.311,34.311,0,0,1,67.6,73.777c-6.363,26-36.069,35.694-56.446,18.241A31.7,31.7,0,0,1,2.169,56.265c3.539-9.753,11.72-17.2,21.306-20.8q-1.712.812-3.347,1.757C12.6,41.564,6.429,48.487,3.832,56.84-.16,68.919,3.226,81.621,13.1,89.74c9.146,7.788,22.792,10.113,33.736,4.933A32.85,32.85,0,0,0,64.215,73a31.806,31.806,0,0,0-2.671-20.932,52.338,52.338,0,0,0-6.826-9.76c-5.562-6.43-13.953-10.556-17.756-18.51C35.21,20.22,34.423,15.9,35.7,12a15.242,15.242,0,0,1,7.971-8.6,13.377,13.377,0,0,1,7.753-.889,15.792,15.792,0,0,1,11.815,8.9",
    transform: "translate(0 -1.402)",
    fill: "#113f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27171",
    "data-name": "Trazado 27171",
    d: "M43.962,122.184c-5.62,3.464-8.945,9.811-9.738,16.222a19.319,19.319,0,0,0,6.832,17.062,21.306,21.306,0,0,0,11.756,5.309,18.928,18.928,0,0,1-12.652-4.228,19.39,19.39,0,0,1-7.627-18.365c1.006-6.662,5.029-13.389,11.426-16",
    transform: "translate(-19.764 -74.78)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27172",
    "data-name": "Trazado 27172",
    d: "M77.571,171.572A15.952,15.952,0,0,0,94.9,169.62a14.571,14.571,0,0,0,4.4-7.8,15.25,15.25,0,0,0-.749-9.169,13.47,13.47,0,0,1,1.784,9.361,14.517,14.517,0,0,1-4.545,8.623c-4.914,4.2-13.06,5.014-18.224.941",
    transform: "translate(-47.476 -93.425)",
    fill: "#c7296f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27173",
    "data-name": "Trazado 27173",
    d: "M78.354,55.1a13,13,0,0,0-5.537-7.247,28.921,28.921,0,0,1-2.584-1.933,6.871,6.871,0,0,1-2.6-4.129c-.557-3.144-1.053-6.3-1.586-9.445q-1.025-6.049-2.068-12.1c-.585-3.488-1.157-6.978-1.756-10.464-.385-2.242-.739-4.494-1.235-6.713A3.947,3.947,0,0,0,56.816.028a3.829,3.829,0,0,0-2.955,3.754,8.192,8.192,0,0,0,.3,2.092q4.873,18.178,9.787,36.347a6.761,6.761,0,0,1-.405,4.851c-.694,1.438-1.486,2.83-2.258,4.229a11.347,11.347,0,0,0-1.517,5.727c0,.211.013.421.022.63a7.44,7.44,0,0,1,7.491.376c4.627,2.707,8.842,1.218,11.685-.65-.173-.761-.374-1.521-.608-2.28M61.179,14.053c-.1-.442-.158-.885-.241-1.323A66.5,66.5,0,0,0,58.8,3.666a17.96,17.96,0,0,1,2.376,10.386M74.958,54.6a10.53,10.53,0,0,0-5.569-5.92,7.447,7.447,0,0,1,5.832,5.84,11.245,11.245,0,0,1,.164,1.222c-.161-.382-.272-.771-.427-1.143",
    transform: "translate(-32.965 0)",
    fill: "#113f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27174",
    "data-name": "Trazado 27174",
    d: "M210.446,160.209c-4.3-4.061-10.292-6.553-16-4.129-6.876,2.984-12.243,12.66-11.955,20.042.255,8.617,6.506,14.1,14.461,8.794A25.612,25.612,0,0,0,207.6,168.651c.49-3.287,1-6.833,1.618-10.095l-.016.22v-.051s-.005-.019.021.091a1.237,1.237,0,0,0,2.337.113,97.979,97.979,0,0,0,.478,14.958,44.2,44.2,0,0,0,3.255,13.353c.255.577.657,1.193.947,1.746-5.454-6.952-6.983-20.17-7.153-28.885l.007-1.02a2.645,2.645,0,0,1,.177-1.163,1.289,1.289,0,0,1,2.44.622c0,.067.014.208.015.268l-.021.149c-.4,2.98-.77,6.339-1.118,9.351a28.088,28.088,0,0,1-9.155,17.325,17.774,17.774,0,0,1-9.188,4.589c-5.035.793-9.791-2.786-11.49-7.332a18.227,18.227,0,0,1-1.23-6.727,23.433,23.433,0,0,1,3.906-12.587c6.628-10.891,18.283-13.709,27.016-3.371",
    transform: "translate(-109.873 -94.11)",
    fill: "#113f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27175",
    "data-name": "Trazado 27175",
    d: "M269.472,159.5c7.516-3.525,20.015-7.669,28.073-4.489a9.991,9.991,0,0,1,3.714,2.566,3.638,3.638,0,0,1,1,3.445,8.181,8.181,0,0,1-1.931,3.32,41.179,41.179,0,0,1-4.78,4.451c-3.241,2.667-6.577,5.157-9.758,7.851a54.748,54.748,0,0,0-7.584,7.474c-.59.784-1.552,1.883-1.384,2.865.189.513.946.873,1.555,1.078,3.838,1.123,8.042.823,12.034.657,4.156-.228,8.319-.685,12.492-1.173-6.767,1.911-18.491,4.624-25.282,2.971-3.469-.895-4.554-3.729-2.725-6.742a24,24,0,0,1,1.958-2.747,74.186,74.186,0,0,1,11.721-10.894c2.73-2.191,7.121-5.375,9.443-7.852a6.038,6.038,0,0,0,1.342-1.975.6.6,0,0,0,.013-.443,8.733,8.733,0,0,0-5.6-3.268c-7.736-1.454-16.752.825-24.3,2.9",
    transform: "translate(-164.926 -94.179)",
    fill: "#113f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27176",
    "data-name": "Trazado 27176",
    d: "M375.245,155.388c-6.253,2.451-11.866,7.644-13.2,14.411a19.4,19.4,0,0,0,1.784,12.7,13.716,13.716,0,0,0,10.083,6.766c8.431,1.491,17.735-3.939,19.726-12.419,2.139-8.908-5.542-17.331-13.8-19.52a14.988,14.988,0,0,0-6.839-.223,14.211,14.211,0,0,1,7.018-.677,20.851,20.851,0,0,1,12.442,6.977c11.887,13.894-2.664,32.032-19.112,29.077-5.018-.87-9.864-3.938-12.1-8.627a20.936,20.936,0,0,1-1.308-14.559c1.907-7.076,8.285-12.337,15.3-13.908",
    transform: "translate(-219.846 -95.103)",
    fill: "#113f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27177",
    "data-name": "Trazado 27177",
    d: "M461.539,156.057c1.387,9.331,2.324,18.719,3.044,28.124q.345,4.706.563,9.425h-2.723c0-.923.019-3.126.016-4.007-.08-8.806-1.462-24.744,6.165-30.78a13.277,13.277,0,0,1,14.526-.624c4.934,3.335,6.971,9.513,7.458,15.176.451,7.247-.731,14.458-1.685,21.616-.475-6.266-.164-12.508-.734-18.748-.37-5.688-1.823-12.043-6.707-15.38-3.772-2.275-9.9-1.482-12.373,2.167-4.222,6.278-3.624,17.735-3.75,25.232,0,1.563-.119,3.845-.191,5.418h-2.723c-.031-3.127-.069-6.258-.137-9.39-.1-6.32-.576-21.7-.747-28.231",
    transform: "translate(-282.478 -95.511)",
    fill: "#113f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27178",
    "data-name": "Trazado 27178",
    d: "M546.244,183.686c4.033-2.124,8.09-4.284,12.03-6.543a31.535,31.535,0,0,0,5.428-3.828c2.12-1.912,4.323-4.657,3.612-7.656-.583-2.269-2.793-3.829-5.007-4.387a11.958,11.958,0,0,0-11.934,4.622c-3.172,4.242-3.984,9.9-3.217,15.07a13,13,0,0,0,9.821,10.877c4.305,1.132,8.817.467,13.037-.836a51.574,51.574,0,0,0,6.324-2.559c-6.51,4.564-15.555,7.8-23.348,4.443-6.068-2.589-9.1-8.633-9.238-15.02-.379-7.335,2.814-15.623,9.92-18.708,4.653-2.13,10.908-1.833,14.471,2.229,4.147,4.693,1.276,10.438-3.055,13.581a39.835,39.835,0,0,1-9.224,4.992c-3.16,1.348-6.359,2.629-9.618,3.723",
    transform: "translate(-332.776 -96.612)",
    fill: "#113f80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSazoneColor);
export default __webpack_public_path__ + "static/media/sazone-color.255bd5c6a4e925ca76bb1077bf2e76f7.svg";
export { ForwardRef as ReactComponent };